module.exports = __webpack_public_path__ + "static/img/right_pic_02.b75569b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right_pic_02.jpg
// module id = i4NY
// module chunks = 1